import { render, staticRenderFns } from "./DialogId12.vue?vue&type=template&id=21a72154&scoped=true&"
import script from "./DialogId12.vue?vue&type=script&lang=js&"
export * from "./DialogId12.vue?vue&type=script&lang=js&"
import style0 from "./DialogId12.vue?vue&type=style&index=0&id=21a72154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a72154",
  null
  
)

export default component.exports